function n(){return"undefined"!=typeof window}export{n as inBrowser};
//# sourceMappingURL=dom.js.map
